import * as $ from 'jquery';
import React, { Component, createRef, useRef, useEffect, useState, Card, CardMedia } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import 'reactjs-popup/dist/index.css';
import { CallAPI, IsInRole } from '../global/APIUtils';
import BreadCumControl from './Controls/BreadcumControl';
import OverlaySpinner from './Controls/OverlaySpinner';
import PostLoginMenu from './PostLoginMenu'
import { MainNavMenu } from './MainNavMenu'
import { Box, Typography, Paper, Grid, Button, Divider, Stack, Tooltip, Link } from '@mui/material';
//import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Footer from './Footer';
import './Modal.css';
import { NavMenu } from './NavMenu';
import './TemplateDesignPreview.css';
import Container from '@mui/material/Container';
import EnrollmentHeader from './EnrollmentHeader';
import { DrawerAppBar } from './AppNavbar';
import pwdimg from '../assets/images/124567.jpg';
import Image from 'material-ui-image'
import { IsError } from '../global/APIUtils';
import { ErrorMessages } from '../common/ErrorMessages';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AlertControl from './Controls/AlertControl';
import AlertWithTitle from './Controls/AlertWithTitle';
import { TemplateStatus, ActivityLogEvent, AOBSystemProcess } from '../common/AOBEnum';
import { goToTop } from '../global/Helpers'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from "react-router-dom";
import LensIcon from '@mui/icons-material/Lens';
import profimg from '../assets/images/profimg.jpg';
import { APICall, WriteToActivityLog } from '../global/Api';
import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import AutoLagoutTimer from '../global/IdleMonitor';
import DispalyApplicationForm from '../global/ApplicationFormDisplay';
import { queue } from 'jquery';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DeleteCoreDataControl from '../dialogs/DeleteCoreDataControl';
// mask helper removed from TemplateDesigner (centralized helper remains for runtime renderers)
import { attachMaskHandlersToRoot, formatWithMask, extractForMask } from '../global/maskHelper';


window.jQuery = $;
window.$ = $;

require("jquery-ui-sortable");
require("formBuilder");

require('formBuilder/dist/form-render.min.js')

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: 0,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const TemplateDesigner = (props) => {

    const fb = useRef(null);
    let formBuilder = useRef(null);
    //let sessions = useSelector((state) => state.sessionMgmnt);
    //const dispatch = useDispatch();
    const [errorMsg, setErrorMsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [expanded, setExpanded] = useState(true);
    const location = useLocation();
    const [openPreview, setOpenPreview] = React.useState(false);
    const [templateId, setTemplateId] = useState(location.state.templateid || -1);
    const [successMsg, setSuccessMsg] = useState(null);
    const [successMsgTitle, setSuccessMsgTitle] = useState(null);
    const [disPublishTmpltBtn, setDisPublishTmpltBtn] = useState(true);
    const [disRefTemplate, setDisRefTemplate] = useState(true);
    const [showDeleteCoreDataControlDlg, setShowDeleteCoreDataControlDlg] = useState(false);

    const [userId, setUserId] = useState(location.state.userId || -1);
    const [sessionId, setSessionId] = useState(location.state.sessionId || '');

    let navigate = useNavigate();

    const handlePreviewClose = () => {
        setOpenPreview(false);
    };

    const typeUserAttrs = {
        text: {
            //className: colStyleClass,
            //maxlength: 20000,
            ExtMapping: {
                'label': 'Ext. Mapping',
                'value': '',
                'type': 'textbox'
            },
            onclick: {
                label: 'onClick',
                value: '',
                type: 'textarea'
            },
            onkeyup: {
                label: 'onKeyup',
                value: '',
                type: 'textarea'
            },
            onload: {
                label: 'onLoad',
                value: '',
                type: 'textarea'
            },
            onkeypress: {
                label: 'onkeypress',
                value: '',
                type: 'textarea'
            },
            onkeydown: {
                label: 'onkeydown',
                value: '',
                type: 'textarea'
            },
            oncut: {
                label: 'onCut',
                value: '',
                type: 'textarea'
            },
            onpaste: {
                label: 'onPaste',
                value: '',
                type: 'textarea'
            },
            ondrop: {
                label: 'onDrop',
                value: '',
                type: 'textarea'
            },
            oninput: {
                label: 'onInput',
                value: '',
                type: 'textarea'
            },
            mask: {
                label: 'Mask',
                // value: '(000) 000-00-00-00',
                value: '',
                type: 'text'
            },
            // promptChar: {
            //     label: 'Prompt Character',
            //     value: '_',
            //     type: 'text'
            // },
            autocomplete: {
                label: 'autocomplete',
                value: null,
                type: 'textarea'
            },
            disabled: {
                label: 'Disabled',
                value: null,
                type: 'checkbox'
            }
        },
        select: {
            ExtMapping: {
                'label': 'Ext. Mapping',
                'value': '',
                'type': 'textbox'
            },
            onchange: {
                label: 'onChange',
                value: '',
                type: 'textarea'
            },
            disabled: {
                label: 'Disabled',
                value: false,
                type: 'checkbox'
            }
        },
        file: {
            //className: colStyleClass,
            disabledAttrs: [
                //'multiple',
                'subtype',
                'access'//,            
            ],
            'maxfilesize': {
                'label': 'Max File Size (MB)',
                'value': '4',
                'type': 'number'
            },
            disabled: {
                label: 'Disabled',
                value: false,
                type: 'checkbox'
            }
        },
        button: {
            //className: colStyleClass,
        },
        'checkbox-group': {
            ExtMapping: {
                'label': 'Ext. Mapping',
                'value': '',
                'type': 'textbox'
            },
            onclick: {
                label: 'onClick',
                value: '',
                type: 'textarea'
            },
            onchange: {
                label: 'onChange',
                value: '',
                type: 'textarea'
            },
            onload: {
                label: 'onLoad',
                value: '',
                type: 'textarea'
            },
            disabled: {
                label: 'Disabled',
                value: false,
                type: 'checkbox'
            }
        },
        'radio-group': {
            ExtMapping: {
                'label': 'Ext. Mapping',
                'value': '',
                'type': 'textbox'
            },
            onchange: {
                label: 'onChange',
                value: '',
                type: 'textarea'
            },
            disabled: {
                label: 'Disabled',
                value: false,
                type: 'checkbox'
            }
        },
        number: {
            ExtMapping: {
                'label': 'Ext. Mapping',
                'value': '',
                'type': 'textbox'
            },
            onkeypress: {
                label: 'onkeypress',
                value: '',
                type: 'textarea'
            },
            onkeydown: {
                label: 'onkeydown',
                value: '',
                type: 'textarea'
            },
            disabled: {
                label: 'Disabled',
                value: false,
                type: 'checkbox'
            }
        },
        //header: {
        //    onkeypress: {
        //        label: 'onkeypress Event',
        //        value: '',
        //        type: 'textarea'
        //    },
        //},
        //"radio-group": {
        //    className: colStyleClass,
        //},
        textarea: {
            //className: colStyleClass,
            ExtMapping: {
                'label': 'Ext. Mapping',
                'value': '',
                'type': 'textbox'
            },
            disabled: {
                label: 'Disabled',
                value: false,
                type: 'checkbox'
            }
        },
        date: {
            //className: colStyleClass,
            ExtMapping: {
                'label': 'Ext. Mapping',
                'value': '',
                'type': 'textbox'
            },
            disabled: {
                label: 'Disabled',
                value: false,
                type: 'checkbox'
            }
        },
        header: {
            adminonly: {
                label: 'Admin only',
                value: false,
                type: 'checkbox',
            },
            onblur: {
                label: 'onBlur',
                value: '',
                type: 'textarea'
            },
            onload: {
                label: 'onLoad',
                value: '',
                type: 'textarea'
            },
        }
    };
    const typeUserDisabledAttrs = {
        'file': [
            'subtype',
            'type',
            'access',
            'multiple'
        ]
    }

    const stickyControl = {
        stickyControls: {
            enable: true,
            offset: {
                top: 20,
                right: 20,
                left: 'auto'
            }
        }
    }

    const loadDesigner = async () => {

        try {

            setIsLoading(true);

            goToTop();

            const apiUrl = new URL(
                process.env.REACT_APP_GET_TEMPLATE_DESIGNER_DETAIL,
                process.env.REACT_APP_BASE_URL,
            );
            apiUrl.searchParams.set('templateId', templateId);

            //let response = await CallAPI({ url: apiUrl.href, method: 'GET', headers: {} }, userId, sessionId);

            let response = await APICall({ url: apiUrl.href, method: 'GET', contentType: 'application/json', responseType: '' }, userId, sessionId);

            if (response !== null && response !== undefined) {

                await PopulateDesigner(response, templateId);
                await WriteToActivityLog(ActivityLogEvent.Template, "Opened template designer.", userId, sessionId);

            }
        }
        catch (err) {
            setErrorMsg(ErrorMessages.UnknownError);
        }
        finally {
            setIsLoading(false);
        }
        return;
    }

    const publishTemplate = async (templateStsId) => {

        let result = await saveData(templateStsId);

        if (result == true) {
            let templateNm = document.getElementById('txtTemplateName').value;

            await WriteToActivityLog(ActivityLogEvent.Template, "Template published. Temlate name '" + templateNm + "'", userId, sessionId);

            setSuccessMsgTitle('Template published');
            setSuccessMsg('The template named as \'' + templateNm + '\' published successfully');
        }

    }

    const saveTemplate = async (templateStsId) => {

        let result = await saveData(templateStsId);

        if (result == true) {
            let templateNm = document.getElementById('txtTemplateName').value;

            await WriteToActivityLog(ActivityLogEvent.Template, "Template saved. Temlate name '" + templateNm + "'", userId, sessionId);

            setSuccessMsgTitle('Template saved');
            setSuccessMsg('The template named as \'' + templateNm + '\' saved successfully');
        }

    }

    const refreshTemplate = async () => {

        setErrorMsg(null);
        setSuccessMsgTitle(null);
        setSuccessMsg(null);

        try {

            //const result = formBuilder.current.actions.save();

            const inputJson = {
                TemplateId: parseInt(templateId)
            };


            const apiUrl = new URL(
                process.env.REACT_APP_REFRESH_TEMPLATE_LOOKUP_DATA,
                process.env.REACT_APP_BASE_URL,
            );


            setIsLoading(true);
            //let response = await CallAPI({ url: apiUrl.href, method: 'POST', headers: {}, body: inputJson }, userId, sessionId);

            let response = await APICall({ url: apiUrl.href, method: 'POST', payload: inputJson, contentType: 'application/json', responseType: '' }, userId, sessionId);

            if (response !== null && response !== undefined) {

                setIsLoading(false);

                let error = IsError(response);

                if (error != 0) {
                    setErrorMsg(response.Errors[0].Message);
                    return false;
                }
                await WriteToActivityLog(ActivityLogEvent.Template, "Template refreshed successfully.", userId, sessionId);

                //formBuilder.current.formData = null;
                loadDesigner();

                setSuccessMsgTitle('Template refreshed');
                setSuccessMsg('Template refreshed successfully');

                return true;
            }
        }
        catch (err) {
            setErrorMsg(ErrorMessages.UnknownError);
            setIsLoading(false);
        }
        finally {

        }

    }

    const saveData = async (templateStsId) => {

        setErrorMsg(null);
        setSuccessMsgTitle(null);
        setSuccessMsg(null);

        const templateNmContent = document.getElementById('txtTemplateName');
        const templateDescContent = document.getElementById('txtTemplateDesc');
        const isPhotoReqContent = document.getElementById('chkIsPhotoReq');
        const templateOnLoad = document.getElementById('txtFrmLoad').value;
        const templateOnSubmit = document.getElementById('txtFrmSubmit').value;

        let templateNm = templateNmContent.value;
        let templateDesc = templateDescContent.value;
        let isPhotoReq = isPhotoReqContent.checked;

        if (templateNm === '' || templateNm === null) {
            setErrorMsg('You need to give a name to this template');
            templateNmContent.focus();
            return false;
        }

        let headers = {
            'Content-Type': 'application/json'
        };

        try {

            const result = formBuilder.current.actions.save();

            // Ensure mask/promptChar metadata persist in the saved form JSON.
            let fbFormData = formBuilder.current.formData;
            try {
                // formData can be a JSON string or an array/object depending on formBuilder
                let parsed = fbFormData;
                let wasString = false;
                if (typeof fbFormData === 'string') {
                    try {
                        parsed = JSON.parse(fbFormData);
                        wasString = true;
                    } catch (e) {
                        // leave as string if parse fails
                    }
                }

                // If parsed is an array of fields, iterate and attach mask metadata when available
                if (Array.isArray(parsed)) {
                    try {
                        const $fbRoot = $(fb.current);
                        const $designFields = $fbRoot.find('.frmb .frmb-field, .frmb .form-field');

                        parsed.forEach(function (fieldObj) {
                            try {
                                if (!fieldObj) return;
                                // Only for text inputs (or those that could be masked)
                                const isText = (fieldObj.type === 'text' || (fieldObj.type || '').toString().toLowerCase() === 'text');
                                if (!isText) return;

                                // Try to locate matching rendered field DOM node by name or by label
                                let $matched = null;
                                if (fieldObj.name) {
                                    $matched = $designFields.filter(function () {
                                        // formBuilder may render data-name or name attribute
                                        const dname = $(this).attr('data-name') || $(this).data('name') || $(this).find('input').attr('name');
                                        return dname && dname.toString() === fieldObj.name.toString();
                                    }).first();
                                }

                                // fallback: try to match by label text
                                if ((!$matched || !$matched.length) && fieldObj.label) {
                                    $matched = $designFields.filter(function () {
                                        const lab = $(this).find('label, .fb-field-label').first().text() || $(this).find('.label').text();
                                        return lab && lab.toString().trim() === fieldObj.label.toString().trim();
                                    }).first();
                                }

                                if ($matched && $matched.length) {
                                    const $input = $matched.find('input[type="text"]').first();
                                    if ($input && $input.length) {
                                        const maskVal = $input.attr('data-mask') || $input.attr('mask') || $matched.attr('data-mask') || $matched.data('mask');
                                        const promptVal = $input.attr('data-promptchar') || $input.attr('promptchar') || $matched.attr('data-promptchar') || $matched.data('promptchar');
                                        if (maskVal) fieldObj.mask = maskVal;
                                        if (promptVal) fieldObj.promptChar = promptVal;
                                    }
                                }
                            } catch (e) {
                                // ignore per-field
                            }
                        });
                    } catch (e) {
                        // ignore
                    }
                }

                // Serialize back to same type as original
                fbFormData = (wasString ? JSON.stringify(parsed) : parsed);
            } catch (e) {
                // if anything fails, fall back to original formData
                fbFormData = formBuilder.current.formData;
            }

            const inputJson = {
                TemplateId: parseInt(templateId),
                TemplateName: templateNm,
                TemplateDesc: templateDesc,
                TemplateValue: fbFormData,
                OnLoadHandler: templateOnLoad,
                OnSubmitHandler: templateOnSubmit,
                TemplateStatusID: templateStsId,
                IsPhotoReq: isPhotoReq
            };

            const apiUrl = new URL(
                process.env.REACT_APP_SAVE_TEMPLATE,
                process.env.REACT_APP_BASE_URL,
            );


            setIsLoading(true);
            //let response = await CallAPI({ url: apiUrl.href, method: 'POST', headers: {}, body: inputJson }, userId, sessionId);

            let response = await APICall({ url: apiUrl.href, method: 'POST', payload: inputJson, contentType: 'application/json', responseType: '' }, userId, sessionId);

            if (response !== null && response !== undefined) {

                setIsLoading(false);

                let error = IsError(response);

                if (error != 0) {
                    setErrorMsg(response.Errors[0].Message);
                    return false;
                }

                let templateID = response["data"][0].TemplateID;
                setTemplateId(templateID);

                return true;
            }
        }
        catch (err) {
            setErrorMsg(ErrorMessages.UnknownError);
            setIsLoading(false);
        }
        finally {

        }

        return false;
    }

    const previewForm = async () => {

        let templateNm = document.getElementById('txtTemplateName').value;

        await WriteToActivityLog(ActivityLogEvent.Template, "Opened temlate preview. Template name: '" + templateNm + "'", userId, sessionId);

        setOpenPreview(true);
    }

    async function PopulateDesigner(response) {

        let hasSavedData = parseInt(templateId) > 0;

        let controlOrder = response.data[0].ControlOrder;
        let hideControl = response.data[0].HideControlList;
        let formData = hasSavedData ? response.data[0].TemplateDetails[0].TemplateValue : response.data[0].DefaultControls;
        let templateData = response.data[0].InputSet;
        let templateNm = hasSavedData ? response.data[0].TemplateDetails[0].TemplateName : '';
        let templateDesc = hasSavedData ? response.data[0].TemplateDetails[0].TemplateDesc : '';

        let onLoadHandler = hasSavedData ? response.data[0].TemplateDetails[0].OnLoadHandler : '';
        let onSubmitHandler = hasSavedData ? response.data[0].TemplateDetails[0].OnSubmitHandler : '';

        let isPhotoReq = hasSavedData ? response.data[0].TemplateDetails[0].IsPhotoReq : false;
        let isChecked = isPhotoReq ? 'checked' : '';

        let prependStr = `<div class="template-design">
                    <label class="template-name">Template Name<span class="required-asterisk" style="display:inline"> *</span></label>
                    <input type="text" id="txtTemplateName" required class="form-control" placeholder="Template Name" autoComplete="off" value="` + templateNm +
            `" /><label class="template-desc">Description</label>
                    <textarea id="txtTemplateDesc" class = "form-control" rows = "2" placeholder = "Description" autoComplete = "off" >` + templateDesc +
            `</textarea><div class="form-check" style="padding-top: 8px;"><input class="form-check-input" type="checkbox" value="" id="chkIsPhotoReq" ` + isChecked +
            `><label class="form-check-label" for="chkIsPhotoReq"> Requires Applicant Photo </label></div>
                    <label style="padding-top: 8px;padding-bottom: 0.3rem">On Load</label>
                    <textarea id="txtFrmLoad" class="form-control" rows = "2" placeholder="Write script here that is executed after the form load" autoComplete = "off" >` + onLoadHandler +
            `</textarea><label style="padding-top: 16px; padding-bottom: 0.3rem">On Submit</label>
                    <textarea id="txtFrmSubmit" class="form-control" rows = "2" placeholder="Write script here that is executed before form submit" autoComplete = "off" >` + onSubmitHandler +
            `</textarea></div>`;

        //let templateCntrlDivStrt = '<div class="template-design">'
        //let templateLabelCntrl = '<label class="template-name">Template Name<span class="required-asterisk" style="display:inline"> *</span></label>'
        //let templateNameCntrl = '<input type="text" id="txtTemplateName" required class="form-control" placeholder="Template Name" autoComplete="off" value="' + templateNm + '" />'
        //let templateDescLabelCntrl = '<label class="template-desc">Description</label>'
        //let templateDescCntrl = '<textarea id="txtTemplateDesc" class = "form-control" rows = "2" placeholder = "Description" autoComplete = "off" >' + templateDesc + '</textarea>'
        //let isPhotoReqCntrl = '<div class="form-check" style="padding-top: 8px;"><input class="form-check-input" type="checkbox" value="" id="chkIsPhotoReq" ' + isChecked + '><label class="form-check-label" for="chkIsPhotoReq"> Requires Applicant Photo </label></div>';
        //let templateCntrlDivEnd = '</div>'

        let options = {
            inputSets: templateData,
            controlOrder: controlOrder,
            disableFields: hideControl,
            prepend: prependStr,
            stickyControls: stickyControl.stickyControls,
            typeUserAttrs: typeUserAttrs,
            typeUserDisabledAttrs: typeUserDisabledAttrs,
            disableHTMLLabels: true,
            fieldRemoveWarn: true,
            scrollToFieldOnAdd: true,
            stickyControls: {
                enable: false
            },
            disabledAttrs: [
                'access'//,
            ],
            i18n: {
                location: process.env.REACT_APP_I18N_LANG
            },
            formData: formData,
            disabledActionButtons: ['clear', 'data', 'save'],
            // NOTE: highlighting (green background) feature removed — keep grouping intact
        };

        // Append a lightweight Masked Input control to the control panel inputSets.
        // This control uses a simple client-side mask (digit placeholder = '0') and
        // default mask: (000) 000-00-00-00 as requested.
        // try {
        //     const maskedControl = {
        //         label: '<span title="Masked Input">Masked Input</span>',
        //         icon: '<i class="fa fa-keyboard" aria-hidden="true"></i>',
        //         fields: [
        //             {
        //                 type: 'text',
        //                 label: 'Masked Input',
        //                 name: 'masked-input',
        //                 className: 'form-control masked-input',
        //                 subtype: 'masked',
        //                 required: false,
        //                 promptChar: '_'
        //             }
        //         ]
        //     };

        //     // If options.inputSets is an array, append; otherwise ensure it's an array
        //     if (!Array.isArray(options.inputSets)) options.inputSets = [];
        //     options.inputSets.push(maskedControl);
        // } catch (e) {
        //     // ignore
        // }

        formBuilder.current = await $(fb.current).formBuilder(options);

        // Lightweight mask handler: attach centralized handlers for masked inputs
        try {
            const $fb = $(fb.current);
            try {
                attachMaskHandlersToRoot(fb.current);
            } catch (err) {
                // ignore attach failures
            }

            // Propagate mask metadata from the field definition/property panel to the actual input
            const propagateMasksToInputs = function () {
                try {
                    const $fb = $(fb.current);
                    const $designFields = $fb.find('.frmb .frmb-field, .frmb .form-field');
                    $designFields.each(function () {
                        try {
                            const $f = $(this);
                            const $input = $f.find('input[type="text"]');
                            if (!$input || !$input.length) return;

                            // formBuilder often stores field settings in a sibling/data attr named 'name' or as data-attr
                            // Try several places to find mask/promptChar: data-mask, mask attribute, or a nested JSON in data-attributes
                            let mask = $f.attr('data-mask') || $f.data('mask') || $input.attr('mask') || $input.data('mask');
                            let promptChar = $f.attr('data-promptchar') || $f.data('promptchar') || $input.attr('promptchar') || $input.data('promptchar');

                            // Some formBuilder setups store the original field JSON on the li as data-field
                            if (!mask || !promptChar) {
                                const dataField = $f.data('field') || $f.attr('data-field');
                                if (dataField) {
                                    try {
                                        const parsed = (typeof dataField === 'string') ? JSON.parse(dataField) : dataField;
                                        if (parsed && parsed.mask) mask = mask || parsed.mask;
                                        if (parsed && parsed.promptChar) promptChar = promptChar || parsed.promptChar;
                                    } catch (e) {
                                        // ignore parse errors
                                    }
                                }
                            }

                            if (mask) $input.attr('data-mask', mask);
                            if (promptChar) $input.attr('data-promptchar', promptChar);

                        } catch (e) {
                            // ignore per-field
                        }
                    });
                } catch (e) {
                    // ignore
                }
            };

            // Call it once now
            try { propagateMasksToInputs(); } catch (e) { }

            // Attach a MutationObserver to the design container to detect when properties change or fields are added/updated
            try {
                const $fbRoot = $(fb.current);
                const designNode = $fbRoot.find('.frmb').get(0);
                if (designNode) {
                    const mo = new MutationObserver(function (mutations) {
                        // Debounce the propagation
                        clearTimeout(window.__frmb_mask_propagate_timeout);
                        window.__frmb_mask_propagate_timeout = setTimeout(function () {
                            propagateMasksToInputs();
                        }, 120);
                    });
                    mo.observe(designNode, { childList: true, subtree: true, attributes: true });
                    // Store observer to disconnect later if needed
                    $fbRoot.data('frmb-mask-mobserver', mo);
                }
            } catch (e) {
                // ignore
            }

            // Property-panel wiring: watch for changes to Mask property inputs and update selected field
            try {
                const attachPropHandlers = function () {
                    const $fbRoot = $(fb.current);

                    // Delegated: detect changes in any input/textarea/select within the property panel area
                    $fbRoot.off('input.templateDesigner.prop change.templateDesigner.prop', '.fb-properties input, .fb-properties textarea, .fb-properties select');
                    $fbRoot.on('input.templateDesigner.prop change.templateDesigner.prop', '.fb-properties input, .fb-properties textarea, .fb-properties select', function (e) {
                        try {
                            const $prop = $(this);
                            // Identify the property label (previous sibling or parent label text)
                            let label = '';
                            const $lbl = $prop.closest('.fb-property').find('label').first();
                            if ($lbl && $lbl.length) label = $lbl.text().trim();

                            // If it's the Mask property, update the selected design field
                            if (label && label.toLowerCase() === 'mask') {
                                const maskVal = $prop.val();
                                // Find currently selected field in design area (formBuilder adds .active or selected class)
                                const $fb = $(fb.current);
                                const $selected = $fb.find('.frmb .form-field.active, .frmb .frmb-field.active').first();
                                if ($selected && $selected.length) {
                                    // Set attribute and update input
                                    const $input = $selected.find('input[type="text"]').first();
                                    if ($input && $input.length) {
                                        $input.attr('data-mask', maskVal);
                                        // reformat current value to new mask
                                        const raw = extractForMask($input.val());
                                        const newFormatted = formatWithMask(raw, maskVal || '', $input.attr('data-promptchar') || '_');
                                        $input.val(newFormatted);
                                    }
                                }

                                // Add a small preview element next to the property input
                                let $preview = $prop.siblings('.mask-preview');
                                if (!$preview || !$preview.length) {
                                    $preview = $('<span class="mask-preview" style="margin-left:8px;color:#666;font-size:0.9em"></span>');
                                    $prop.after($preview);
                                }
                                // Show a sample using placeholders
                                try {
                                    const sample = formatWithMask('ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789', maskVal || '', '_');
                                    $preview.text(sample);
                                } catch (e) {
                                    $preview.text('Invalid mask');
                                }
                            }
                        } catch (e) {
                            // ignore property handler errors
                        }
                    });
                };

                attachPropHandlers();

                // Some versions of formBuilder recreate the properties panel; observe and reattach
                const $fbRoot = $(fb.current);
                const propNode = $fbRoot.find('.fb-properties').get(0);
                if (propNode) {
                    const pmo = new MutationObserver(function () { attachPropHandlers(); });
                    pmo.observe(propNode, { childList: true, subtree: true });
                    $fbRoot.data('frmb-props-mobserver', pmo);
                }
            } catch (e) {
                // ignore
            }
        } catch (e) {
            // ignore
        }

        // NOTE: removed highlight/green-background code — grouping functionality remains

        // Initial highlight & group initialization after load
        // Wait until the control panel DOM is present before building groups (poll up to ~2s)
        (async function initControlPanelGroups() {
            try {
                const $fb = $(fb.current);
                let attempts = 0;
                let $controlPanel, $items, total;
                while (attempts < 20) {
                    $controlPanel = $fb.find('.frmb-control');
                    if ($controlPanel.length) {
                        $items = $controlPanel.find('li');
                        total = $items.length;
                        if (total && total > 0) break;
                    }
                    attempts++;
                    // wait 100ms
                    // eslint-disable-next-line no-await-in-loop
                    await new Promise((r) => setTimeout(r, 100));
                }

                // If control panel not found, bail out
                if (!$controlPanel || !$controlPanel.length || !$items || $items.length === 0) {
                    return;
                }

                // annotate index on items for stable grouping (1-based)
                $items.each(function (i) {
                    $(this).attr('data-fb-index', i + 1);
                });

                // Always-visible range: 1..11
                const alwaysStart = 1;
                const alwaysEnd = Math.min(11, total);
                const $alwaysItems = $items.filter(function () {
                    const idx = parseInt($(this).attr('data-fb-index'), 10);
                    return idx >= alwaysStart && idx <= alwaysEnd;
                });
                // Ensure always-visible items are shown
                $alwaysItems.show();

                // build collapsible headers container for groups (placed after the always-visible items)
                const $groupsContainer = $('<div class="frmb-groups-container" style="margin:6px 0;"></div>');

                // (will insert groupsContainer after group lists are created below)

                // Build dynamic groups based on inputSets (templateData). Only entries with a non-empty
                // WrkflNm will be considered for grouping. Items with null/empty WrkflNm remain ungrouped
                // and will be displayed directly in the control panel.
                let categories = [];
                // Collect groupable flags for templateData entries (true = has WrkflNm)
                const templateGroupable = [];
                try {
                    if (Array.isArray(templateData) && templateData.length) {
                        // Build WrkflNm list and counts; deduplicate by WrkflNm so same-WrkflNm entries form one group
                        const titleCounts = {};
                        const titleOrder = [];
                        templateData.forEach(function (ts) {
                            const title = ts && ts.WrkflNm ? ts.WrkflNm.toString().trim() : null;
                            // Record whether this templateData entry should be grouped
                            templateGroupable.push(Boolean(title));
                            if (!title) return; // skip non-groupable entries
                            if (!titleCounts[title]) {
                                titleCounts[title] = 0;
                                titleOrder.push(title);
                            }
                            titleCounts[title]++;
                        });

                        // Build categories array (unique titles, preserving order)
                        categories = titleOrder.slice();

                        // We'll later use titleCounts to determine how many items to allocate to each category
                        // Attach titleCounts to closure for use below
                        categories.__titleCounts = titleCounts;
                    }
                } catch (e) {
                    // ignore and fallback below
                }

                // fallback to numeric groups if no categories found
                if (!categories || categories.length === 0) {
                    categories = ['Group 1', 'Group 2', 'Group 3'];
                }

                // assign group index to each item after the always-visible range.
                // We allocate items in consecutive blocks according to the counts for each title so
                // multiple templateData entries with the same title will result in the same group containing multiple items.
                const $afterAlways = $items.filter(function () {
                    const idx = parseInt($(this).attr('data-fb-index'), 10);
                    return idx > alwaysEnd;
                });

                // Determine allocation counts per category
                const allocCounts = [];
                if (categories.__titleCounts) {
                    const tc = categories.__titleCounts;
                    categories.forEach(function (cat) {
                        allocCounts.push(tc[cat] || 1);
                    });
                } else {
                    // If no titleCounts available, distribute evenly (1 each then round-robin)
                    const per = Math.max(1, Math.floor($afterAlways.length / categories.length));
                    for (let i = 0; i < categories.length; i++) allocCounts.push(per);
                }

                // Assign group indices sequentially by consuming allocCounts.
                // Skip any $afterAlways items that correspond to non-groupable templateData entries
                let cursor = 0; // index into $afterAlways and templateGroupable
                for (let gi = 0; gi < categories.length; gi++) {
                    const take = allocCounts[gi] || 1;
                    let assigned = 0;
                    while (assigned < take && cursor < $afterAlways.length) {
                        const $el = $afterAlways.eq(cursor);
                        const isGroupable = (templateGroupable.length > cursor) ? templateGroupable[cursor] : true;
                        if (isGroupable) {
                            if ($el && $el.length) {
                                $el.attr('data-group-index', gi + 1);
                            }
                            assigned++;
                        }
                        cursor++;
                    }
                }

                // If there are leftover items not assigned (more controls than counts), assign them round-robin
                // but skip non-groupable items so they remain ungrouped.
                let leftoverIndex = 0;
                while (cursor < $afterAlways.length) {
                    const $el = $afterAlways.eq(cursor);
                    if (!$el || !$el.length) break;
                    const isGroupable = (templateGroupable.length > cursor) ? templateGroupable[cursor] : true;
                    if (isGroupable && categories.length) {
                        const gi = (leftoverIndex % categories.length) + 1;
                        $el.attr('data-group-index', gi);
                        leftoverIndex++;
                    }
                    cursor++;
                }

                // Create group headers as <li> elements inside the original control panel so that
                // the existing control <li> elements remain in-place (this preserves drag behavior).
                if ($('#frmb-collapse-styles').length === 0) {
                    // Keep the group header visually consistent with other card-like components
                    // Neutral white background, subtle border, rounded corners, and a soft hover elevation.
                    const css = '\n/* Group accordion styles - app-consistent */'
                        // + '\n.frmb-control .frmb-group-header{user-select:none;pointer-events:auto;z-index:5;display:flex;justify-content:space-between;align-items:center;padding:9px 10px;background:#ffffff;border:1px solid rgba(16,24,40,0.06);border-radius:8px;cursor:pointer;font-weight:600;color:rgba(0,0,0,0.85);font-size:0.95rem;box-shadow:0 1px 2px rgba(16,24,40,0.03);transition:box-shadow 180ms ease, transform 180ms ease;}'
                        + '\n.frmb-control .frmb-group-header{user-select:none;pointer-events:auto;z-index:5;display:flex;justify-content:space-between;align-items:center;cursor:pointer;font-weight:900;margin:-9px -9px -9px -20px;padding:9px 10px 9px 20px;}'
                        // + '\n.frmb-control .frmb-group-header:hover{transform:translateY(-2px);box-shadow:0 0px 0px rgba(16,24,40,0.06);}'
                        + '\n.frmb-control li.frmb-group-header-li{list-style:none;margin:0px 0;padding:0;}'
                        + '\n.frmb-control .frmb-group-label{display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1 1 auto;min-width:0;margin-right:8px;}'
                        + '\n.frmb-control .frmb-group-toggle{flex:0 0 auto;display:inline-block;transition:transform 160ms ease;color:rgba(74,85,104,0.9);font-size:25px;margin-left:8px;line-height:1;}'
                        + '\n.frmb-control .frmb-group-header[aria-expanded="true"] .frmb-group-toggle{transform:rotate(90deg);color:rgba(0,0,0,0.6);}'
                        + '\n.frmb-control li.frmb-group-header-li .frmb-group-header:focus{outline:2px solid rgba(30,136,229,0.12);outline-offset:2px;border-radius:6px;}'
                        + '\n.frmb-control li.frmb-group-header-li.no-drag{cursor:default;background:transparent;}'
                        + '\n.frmb-control li.control-item{transition:background 140ms ease;padding:6px 8px;border-radius:6px;background:transparent;}'
                        + '\n.frmb-control li.control-item:hover{background:rgba(30,136,229,0.03);}';
                    $('<style id="frmb-collapse-styles">' + css + '</style>').appendTo('head');
                }

                categories.forEach(function (catName, idx) {
                    const gi = idx + 1;
                    const label = catName + (categories.__titleCounts ? ' (' + (categories.__titleCounts[catName] || 0) + ')' : '');

                    // header element (div) inside an li so it lives in the control-panel list
                    const $hdr = $(
                        '<div class="frmb-group-header" role="button" tabindex="0" data-group-index="' + gi + '" aria-expanded="false">' +
                        '  <span class="frmb-group-label">' + label + '</span>' +
                        '  <span class="frmb-group-toggle">▸</span>' +
                        '</div>'
                    );

                    // Set native tooltip (title) and aria-label for accessibility using jQuery.attr to avoid HTML-escaping issues.
                    try {
                        const safeLabel = (label || '').toString().replace(/"/g, '\\"').replace(/\'/g, "\\'");
                        $hdr.attr('title', safeLabel);
                        $hdr.attr('aria-label', safeLabel);
                    } catch (e) {
                        // ignore
                    }
                    // Mark this li explicitly as a group-header so other code (and formBuilder internals)
                    // can distinguish it from regular control items. Keep no-drag to avoid being picked up
                    // by drag handlers.
                    const $hdrLi = $('<li class="frmb-group-header-li no-drag" data-type="group-header" data-group-index="' + gi + '"></li>');
                    $hdrLi.attr('draggable', false).append($hdr);
                    // Prevent header from being dragged or picked as a control
                    $hdrLi.on('dragstart.templateDesigner pointerdown.templateDesigner mousedown.templateDesigner touchstart.templateDesigner', function (e) {
                        try {
                            e.preventDefault();
                            e.stopPropagation();
                        } catch (ex) { }
                        return false;
                    });

                    // find group's original items (they remain in $items)
                    const $groupItems = $items.filter(function () {
                        return parseInt($(this).attr('data-group-index') || '0', 10) === gi;
                    });

                    // insert header li before the group's first item so items appear under header
                    const $first = $groupItems.first();
                    if ($first.length) {
                        $first.before($hdrLi);
                    } else {
                        // if no items, append header to control panel
                        $controlPanel.append($hdrLi);
                    }

                    // hide group's items initially and set toggle icon
                    $groupItems.hide();
                    $hdr.find('.frmb-group-toggle').text('▸');
                });

                // Move the Masked Input control to appear before the first group header
                try {
                    // Find the first group header li
                    const $firstGroupHeader = $controlPanel.find('li.frmb-group-header-li').first();
                    if ($firstGroupHeader && $firstGroupHeader.length) {
                        // Find control li that corresponds to our masked control by label text
                        const $maskedLi = $controlPanel.find('li').filter(function () {
                            return ($(this).text() || '').toString().trim().indexOf('Masked Input') !== -1;
                        }).first();

                        if ($maskedLi && $maskedLi.length) {
                            $firstGroupHeader.before($maskedLi);
                        }
                    }
                } catch (e) {
                    // ignore move failures
                }

                // click handler: toggle group's original li elements (delegated on control panel)
                // Improve header toggle sync: ensure icons and aria-expanded match the actual group visibility
                $controlPanel.off('click.templateDesigner', '.frmb-group-header');
                // Intercept header clicks and handle expand/collapse locally. Stop propagation so
                // formBuilder's internal click handlers don't attempt to treat headers as controls
                // (which previously caused an undefined.replace() runtime error).
                $controlPanel.on('click.templateDesigner', '.frmb-group-header', function (e) {
                    try {
                        e && e.preventDefault();
                        e && e.stopPropagation();
                    } catch (ex) { }

                    const $btn = $(this);
                    const gi = parseInt($btn.attr('data-group-index'), 10);

                    const $groupItems = $items.filter(function () {
                        return parseInt($(this).attr('data-group-index') || '0', 10) === gi;
                    });

                    const isAnyVisible = $groupItems.filter(':visible').length > 0;

                    if (isAnyVisible) {
                        // collapse this group
                        $groupItems.stop(true, true).slideUp(120);
                    } else {
                        // collapse other groups then expand this
                        categories.forEach(function (c, idx) {
                            const oGi = idx + 1;
                            if (oGi === gi) return;
                            const $others = $items.filter(function () {
                                return parseInt($(this).attr('data-group-index') || '0', 10) === oGi;
                            });
                            $others.stop(true, true).slideUp(120);
                        });

                        $groupItems.stop(true, true).slideDown(120);
                    }

                    // After animations finish (slightly longer than 120ms) sync all header icons/aria attributes
                    setTimeout(function () {
                        $controlPanel.find('.frmb-group-header').each(function () {
                            const $h = $(this);
                            const hGi = parseInt($h.attr('data-group-index') || '0', 10);
                            const $hItems = $items.filter(function () {
                                return parseInt($(this).attr('data-group-index') || '0', 10) === hGi;
                            });
                            const visible = $hItems.filter(':visible').length > 0;
                            $h.attr('aria-expanded', visible ? 'true' : 'false');
                            $h.find('.frmb-group-toggle').text(visible ? '▾' : '▸');
                        });
                    }, 180);
                });

                // all groups are intentionally left collapsed by default
                // Assign stable UIDs to control-panel items and attach pick handlers
                try {
                    // Filter out header/list items that should not act as controls
                    const $controlPanelItems = $items.filter(function () {
                        return !$(this).hasClass('frmb-group-header-li') && !$(this).hasClass('no-drag');
                    });

                    $controlPanelItems.each(function (index) {
                        const $li = $(this);
                        if (!$li.attr('data-ctrl-uid')) {
                            // create uid predictable for this session
                            const uid = 'ctrl-uid-' + (index + 1) + '-' + Date.now();
                            $li.attr('data-ctrl-uid', uid);
                        }

                        // ensure we don't attach twice
                        $li.off('pointerdown.templateDesigner mousedown.templateDesigner touchstart.templateDesigner dragstart.templateDesigner');
                        $li.on('pointerdown.templateDesigner mousedown.templateDesigner touchstart.templateDesigner dragstart.templateDesigner', function (e) {
                            try {
                                window.__lastPickedControlUid = $(this).attr('data-ctrl-uid');
                            } catch (ex) {
                                // ignore
                            }
                        });
                    });

                    // Fallback: annotate existing design fields (loaded templates) by matching types to available uids
                    try {
                        const $designFields = $fb.find('.frmb li.form-field');
                        const availableByType = {};
                        $controlPanelItems.each(function () {
                            const $c = $(this);
                            const type = ($c.attr('data-type') || '').toString().trim();
                            const uid = $c.attr('data-ctrl-uid');
                            if (type && uid) {
                                availableByType[type] = availableByType[type] || [];
                                availableByType[type].push(uid);
                            }
                        });

                        $designFields.each(function () {
                            const $f = $(this);
                            if (!$f.attr('data-ctrl-uid')) {
                                const ftype = ($f.attr('type') || '').toString().trim();
                                if (ftype && availableByType[ftype] && availableByType[ftype].length) {
                                    const takeUid = availableByType[ftype].shift();
                                    $f.attr('data-ctrl-uid', takeUid);
                                }
                            }
                        });
                    } catch (e) {
                        console.warn('Design field fallback uid mapping failed', e);
                    }
                } catch (err) {
                    console.warn('Could not assign control-panel UIDs or handlers', err);
                }
            } catch (err) {
                console.error('Error building collapsible groups', err);
            }
        }());

        // Note: highlight-related MutationObserver removed — grouping and drag behavior remain unchanged
    }
    useEffect(() => {

        let isAdmin = IsInRole(AOBSystemProcess.AllProcess, userId, sessionId);
        let canPublish = IsInRole(AOBSystemProcess.PublishTemplate, userId, sessionId) || isAdmin;

        if (canPublish) {
            setDisPublishTmpltBtn(false);
        }

        if (templateId > 0) {
            setDisRefTemplate(false);
        }

        loadDesigner();
    }, []);



    const handleAccordianChange = () => {
        if (expanded) {
            setExpanded(false);
        }
        else {
            setExpanded(true);
        }
    }

    const handleBackClick = () => {
        navigate('/TemplateList', { state: { userId: userId, sessionId: sessionId }, replace: true });
    }

    const GetTemplateName = () => {

        const templateNmContent = document.getElementById('txtTemplateName');

        let templateNm = templateNmContent && templateNmContent.value ? 'APPLICATION FORM TEMPLATE - ' + templateNmContent.value : 'APPLICATION FORM TEMPLATE';

        return templateNm;
    }

    const handleDeleteClick = (event) => {
        navigate('/DeleteCoreDataControl', { state: { userId: userId, sessionId: sessionId, templateid: templateId }, replace: true });
    };

    const closeDeleteCoreDataControlDlg = (msg) => {
        setShowDeleteCoreDataControlDlg(false);
        if (msg != null) {
            setSuccessMsg(msg);
            loadDesigner();
        }
        //refetch();
    }

    return (

        <React.Fragment>
            <AutoLagoutTimer userId={userId} sessionId={sessionId} />
            <Container maxWidth="lg" sx={{}} className="" disableGutters={true}>
                <OverlaySpinner disappear={isLoading} />
                <Paper className="back-grid">
                    <PostLoginMenu userId={userId} sessionId={sessionId} />
                    <Grid item md={12} id="aobhead" >
                        <Box sx={{
                            pr: 0,
                            pl: 0,
                        }}>
                            <EnrollmentHeader />
                        </Box>
                    </Grid>
                    <Grid item sx={{ pr: 1 }}>
                        <DrawerAppBar userId={userId} sessionId={sessionId} />
                    </Grid>
                    <Grid item container direction="row" spacing={0} sx={{ pt: 0, pb: 0, }}>
                        <Grid item xs={12} sx={{}}>
                            <Box sx={{ display: 'flex', pb: 2, pt: 0, ml: 9, mr: 9, justifyContent: 'space-between', alignItems: 'flex-end', borderBottom: '0px solid #898F94' }}>
                                <Typography variant="h6" color="text.primary" sx={{ pl: 0, pb: 0, lineHeight: 1, fontWeight: 500, pb: 0 }} >
                                    {(templateId !== null && templateId !== undefined && templateId !== -1) ? "Edit " : "New "}Template
                                </Typography>
                            </Box>
                            <Box sx={{}}>
                                <Divider variant="fullWidth" component="div" sx={{}} />
                            </Box>
                        </Grid>
                        <Grid item xs={9} sx={{}}>
                            <Box sx={{ mt: 0, pt: 3, pb: 2, ml: 9, mr: 6.5, borderTop: '0px solid #A8B3B3', borderBottom: '0px solid #d2d2d2' }}>
                                <Stack direction="column" sx={{ width: '99%' }}>
                                    <Typography sx={{ pl: 0, fontWeight: 400, }} variant="body1" color="text.primary">
                                        Create Account Form by using this account form designer. Use it to design, create,
                                        and update account openning forms. This utility gives access to a drawing canvas
                                        upon which you construct your forms, a design toolbar from which you access
                                        controls and layout objects, and a properties view that you use to set
                                        attributes for each control or layout object.
                                    </Typography>
                                </Stack>
                            </Box>
                        </Grid>
                        <Grid item xs={3}>
                            <Box alignItems="center" sx={{ mr: 9, pb: 0, pt: 3.5, display: 'flex', }}>
                                <Stack direction="column" spacing={2} alignItems="center">
                                    <Box>
                                        <Stack direction="column" spacing={2}>
                                            <Button variant="contained" size="large" style={{ boxShadow: 'none', border: 0, borderRadius: '20px', padding: '0.3rem 2.5rem', outline: 'none', textTransform: 'none' }} onClick={() => previewForm()}>
                                                Preview
                                            </Button>
                                            <Button variant="contained" size="large" style={{ boxShadow: 'none', border: 0, borderRadius: '20px', padding: '0.3rem 2.5rem', outline: 'none', textTransform: 'none' }} onClick={() => saveTemplate(TemplateStatus.InProgress)}>
                                                Save
                                            </Button>
                                            <Button variant="contained" size="large" disabled={disPublishTmpltBtn} style={{ boxShadow: 'none', border: 0, borderRadius: '20px', padding: '0.3rem 2.5rem', outline: 'none', textTransform: 'none' }} onClick={() => publishTemplate(TemplateStatus.Published)}>
                                                Publish
                                            </Button>
                                            {/*                               <Button variant="contained" size="large" disabled={disRefTemplate} style={{ boxShadow: 'none', border: 0, borderRadius: '20px', padding: '0.3rem 2.5rem', outline: 'none', }} onClick={() => refreshTemplate()}>*/}
                                            {/*                                   REFERSH*/}
                                            {/*                               </Button>                                    */}
                                        </Stack>
                                    </Box>
                                </Stack>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid item>
                        {/*<Box alignItems="center" sx={{ mr: 9, pb: 0, pt: 1, pl: 7, display: 'flex', justifyContent: 'flex-end' }}>*/}
                        {/*    <Stack direction="row" spacing={2} alignItems="center">*/}
                        {/*        <Box>*/}
                        {/*            <Stack direction="row" spacing={2} alignItems="center">*/}
                        {/*                <Button variant="contained" size="large" style={{ boxShadow: 'none', border: 0, borderRadius: '20px', padding: '0.3rem 2.5rem', outline: 'none', }} onClick={() => saveTemplate(TemplateStatus.InProgress)}>*/}
                        {/*                    SAVE*/}
                        {/*                </Button>*/}
                        {/*                <Button variant="contained" size="large" disabled={disPublishTmpltBtn} style={{ boxShadow: 'none', border: 0, borderRadius: '20px', padding: '0.3rem 2.5rem', outline: 'none', }} onClick={() => publishTemplate(TemplateStatus.Published)}>*/}
                        {/*                    PUBLISH*/}
                        {/*                </Button>*/}
                        {/*                <Button variant="contained" size="large" style={{ boxShadow: 'none', border: 0, borderRadius: '20px', padding: '0.3rem 2.5rem', outline: 'none', }} onClick={() => previewForm()}>*/}
                        {/*                    PREVIEW*/}
                        {/*                </Button>*/}
                        {/*            </Stack>*/}
                        {/*        </Box>*/}
                        {/*    </Stack>*/}
                        {/*</Box>*/}
                        <Box sx={{ ml: { xs: 3, md: 9 }, mr: { xs: 3, md: 9 }, pt: 1 }}>
                            <AlertControl Message={errorMsg} severity="error" color="error" icon={true} />
                            <AlertWithTitle Message={successMsg} variant="body3" severity="success" color="success" icon={true} Title={successMsgTitle} />
                        </Box>
                    </Grid>
                    <Grid item>
                        <Box sx={{ pb: 3 }}>
                            <Divider variant="fullWidth" component="div" sx={{}} />
                        </Box>
                    </Grid>
                    <Grid item>
                        <Paper elevation={1} sx={{
                            mr: { xs: 3, md: 8 },
                            ml: { xs: 3, md: 8 },
                            pt: 0.5, pb: 4, mt: 0,
                            borderTop: '1px solid #D5D9D9', borderRadius: '6px', boxShadow: '0 1px 3px 0 #D5D9D9, 0 0 0 1px rgba(0,0,0,.05)'
                        }}>
                            <Box sx={{ borderBottom: '1px solid #BFC5C5', pl: 0, pr: 2, display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1" color="text.blueText" sx={{ pt: 1, textTransform: 'none', fontWeight: 400, pl: 4.5, letterSpacing: '0px' }} >Template Designer</Typography>
                                <Typography variant="caption" color="text.primary" sx={{ textTransform: 'none', pt: 2, fontWeight: 400, pr: 1, pb: 1 }} >drag a control from control panel to the left design panel</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1 }}>
                                <Stack direction="row">
                                    <Tooltip arrow title="Delete From Control Panel">
                                        <span>
                                            <IconButton size="small" sx={{ border: 0, borderColor: '#d7d8d6', borderRadius: '5px', ml: 0, mr: 0, mb: 0 }} onClick={handleDeleteClick}>
                                                <DeleteForeverOutlinedIcon sx={{ fontSize: 22, color: 'Icon.main' }} />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Typography variant="body1" color="text.secondary" sx={{ textTransform: 'none', textAlign: 'right', pt: 0.5, fontWeight: 600, pr: 5.5 }} >Control panel</Typography>
                                </Stack>
                            </Box>
                            <Box color="text.primary" sx={{ pl: 4.5, pt: 0.5, pr: 5, }} id="fb-editor" ref={fb} />
                        </Paper>
                    </Grid>
                    <Dialog
                        fullScreen
                        open={openPreview}
                        onClose={handlePreviewClose}
                    >
                        <AppBar sx={{ position: 'relative' }}>
                            <Toolbar>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={handlePreviewClose}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                                <Typography sx={{ ml: 2, flex: 1 }} variant="body1" color="inherit" component="div">
                                    {GetTemplateName()}
                                </Typography>
                                <Button autoFocus color="inherit">
                                    Preview
                                </Button>
                            </Toolbar>
                        </AppBar>
                        <DispalyApplicationForm data={formBuilder.current ? formBuilder.current.formData : null} />
                    </Dialog>
                    <Footer userId={userId} />
                </Paper>
            </Container>
            {showDeleteCoreDataControlDlg ?
                <DeleteCoreDataControl open={showDeleteCoreDataControlDlg} onClose={closeDeleteCoreDataControlDlg} userId={userId} sessionId={sessionId} />
                : null
            }
        </React.Fragment>
    );
}


const TemplateDesignerBreadcrumb = (props) => {

    return (
        <React.Fragment >
            <Box sx={{ borderBottom: '0px solid #cdcfd2', pt: 2, pb: 2, background: '#F6F6F6', pl: 2 }}>
                <Typography variant="h6" color="#002d72" sx={{ lineHeight: 1, fontWeight: 500 }} >{props.text}</Typography>
            </Box>
            {/*    <Box sx={{ borderBottom: '1px solid #cdcfd2', pt: 0, pb: 3 }}>*/}
            {/*        <Typography variant="h5" color="text.primary" sx={{ lineHeight: 1, fontWeight: 400, letterSpacing: '-1px' }} >{props.text}</Typography>*/}
            {/*    </Box>*/}
        </React.Fragment>
    );
}

export default TemplateDesigner;